import { QueryClient } from "@tanstack/react-query";
import { getCsfrToken } from "./utils";
export async function fetchJson(url, options) {
    const result = await fetch(url, {
        ...options,
        headers: {
            "X-CSRF-TOKEN": getCsfrToken(),
            "Content-Type": "application/json",
            ...(options?.headers && { ...options.headers }),
        },
    });
    if (!result.ok) {
        throw new Error(result.statusText);
    }
    const data = await result.json();
    return data;
}
export const queryClient = new QueryClient();
